import ICON__plus_solid from '@/assets/icons/font_awesome/plus-solid.svg?react';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar_8_3 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_8_3';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { assert_equal } from '@shared/asserts/utils_asserts';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { FIELD__list_base_generic } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_base_generic';
import { useMemo } from 'react';

interface PROPS {
  field: FIELD__list_base_generic<FIELD__base>;
}

export function G_BUTTON__graph_field_list_item_add({ field }: PROPS) {
  /*
   * STORE
   */

  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_graph__field_hovered, g_general__ui_disabled } = use_slice_ui(['g_graph__field_hovered', 'g_general__ui_disabled']);
  const { graph } = generation_current.tool;

  /*
   * STATE
   */
  const is_hovered = useMemo(() => {
    return g_graph__field_hovered.field_id === field.meta.field_id;
  }, [g_graph__field_hovered.field_id, field.meta.field_id]);

  /*
   * EVENTS
   */
  async function onClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();

    assert_equal(graph.meta.graph_id, field.meta.graph_id);

    let field_new = field.clone();

    let item_new = field_new.create_item_new();

    let graph_new = graph.clone();

    graph_new.field__replace(field_new);

    await UTILS__graph_data.update(graph_new);
  }

  /*
   * METHODS
   */
  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   * HTML
   */

  if (field.buttons_add_remove_are_disabled) return <PLACEHOLDER_BUTTON__bar_8_3 />;
  if (graph.meta.graph_id !== field.meta.graph_id) return <PLACEHOLDER_BUTTON__bar_8_3 />;
  if (!is_hovered) return <PLACEHOLDER_BUTTON__bar_8_3 />;

  return (
    <UI_PRIMITIVE__button size={'rect-8-3'} variant={'no-border-on-component'} disabled={is_disabled()} {...{ onClick }} title="Add item">
      <ICON__plus_solid className="!size-3" />
    </UI_PRIMITIVE__button>
  );
}
